/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DialogBase from "../../../../Basis/Components/DialogBase";
import DialogContentFieldset from "../../../../Basis/Components/DialogContentFieldset";
import DialogContentFieldsetGroup from "../../../../Basis/Components/DialogContentFieldsetGroup";
import TextInput from "../../../../Basis/Components/TextInput";
import { nameof } from "../../../../Basis/Utils/AnyUtil";
import AendereEigenesPasswort, { AendereEigenesPasswortInput } from "../../Commands/AendereEigenesPasswort";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";
import AendereEigenesPasswortDialogModel from "./AendereEigenesPasswortDialogModel";
import AendereEigenesPasswortDialogProps from "./AendereEigenesPasswortDialogProps";
import AendereEigenesPasswortDialogState from "./AendereEigenesPasswortDialogState";

export default function AendereEigenesPasswortDialog(props: AendereEigenesPasswortDialogProps) {
    const vm = new AendereEigenesPasswortDialogModel(props);
    const { t } = useTranslation();
    return (
        <DialogBase open={vm.isOpen} scroll="body">
            <DialogTitle>{t(translationKeys.aendereEigenesPasswortDialog.caption)}</DialogTitle>
            <DialogContent>
                <DialogContentFieldsetGroup>
                    <DialogContentFieldset>
                        <TextInput
                            caption={t(translationKeys.aendereEigenesPasswortDialog.aktuellesPasswort)}
                            value={vm.state.aktuellesPasswort}
                            onChange={vm.aendereWertFuer(nameof<AendereEigenesPasswortDialogState>("aktuellesPasswort"))}
                            typBezeichnung={AendereEigenesPasswort.commandName}
                            feldBezeichnung={nameof<AendereEigenesPasswortInput>("aktuellesPasswort")}
                            type="password"
                            required
                            autoFocus
                        />
                        <TextInput
                            caption={t(translationKeys.aendereEigenesPasswortDialog.neuesPasswort)}
                            value={vm.state.neuesPasswort}
                            onChange={vm.aendereWertFuer(nameof<AendereEigenesPasswortDialogState>("neuesPasswort"))}
                            typBezeichnung={AendereEigenesPasswort.commandName}
                            feldBezeichnung={nameof<AendereEigenesPasswortInput>("neuesPasswort")}
                            type="password"
                            required
                            tooltip={t(translationKeys.aendereEigenesPasswortDialog.tooltip)}
                        />
                        <TextInput
                            caption={t(translationKeys.aendereEigenesPasswortDialog.neuesPasswortWiederholung)}
                            value={vm.state.neuesPasswortWiederholung}
                            onChange={vm.aendereWertFuer(nameof<AendereEigenesPasswortDialogState>("neuesPasswortWiederholung"))}
                            typBezeichnung={AendereEigenesPasswort.commandName}
                            feldBezeichnung={nameof<AendereEigenesPasswortInput>("neuesPasswortWiederholung")}
                            type="password"
                            required
                        />
                    </DialogContentFieldset>
                </DialogContentFieldsetGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={vm.aendereEigenesPasswort} color="primary">
                    {t(translationKeys.aendereEigenesPasswortDialog.aendern)}
                </Button>
                <Button onClick={vm.abbrechen} color="primary">
                    {t(translationKeys.aendereEigenesPasswortDialog.abbrechen)}
                </Button>
            </DialogActions>
        </DialogBase>
    );
}
